import { Text, View } from "@react-pdf/renderer";
import ContractListItem from "./listItem";
import { getChildSerialNumber } from "./serialNumbers";

const renderClauseContent = (content) => {
  if (typeof content !== "string" || !content.includes("\n")) {
    return content;
  }

  return content.split("\n").map((line, index, lines) => (
    <Text key={`${line}-${index}`}>
      {line}
      {index < lines.length - 1 ? "\n" : null}
    </Text>
  ));
};

const RenderClauses = ({
  clauses = [],
  styles,
  level = 0,
  number = "",
  getTextStyle,
  keepTogether = false,
}) => (
  <View
    style={[
      styles.flexColumn,
      styles.gap_sm,
      { paddingLeft: level === 0 ? 24 : 0 },
      { break: level === 0 && number === "4.8." },
    ]}
  >
    {clauses.map(({ content, subContent = [] }, index) => {
      const clauseNumber = getChildSerialNumber(number, index);
      return (
      <View
        key={`${clauseNumber}-${content}`}
        style={[styles.flexColumn, styles.gap_xs, { paddingTop: 12}]}
        break={
          clauseNumber === "4.4.4." ||
          clauseNumber === "4.8." ||
          (keepTogether && clauseNumber === "11.4.")
        }
        wrap={!keepTogether}
      >
        <ContractListItem
          marker={clauseNumber}
          markerWidth={level === 0 ? 48 : 64}
          styles={styles}
          textStyle={
            getTextStyle
              ? getTextStyle(content, clauseNumber, level)
              : styles.buttonTextSmall
          }
          wrap={!keepTogether && level === 0}
        >
          {renderClauseContent(content)}
        </ContractListItem>
        {subContent.length > 0 && (
          <RenderClauses
            clauses={subContent}
            styles={styles}
            level={level + 1}
            number={clauseNumber}
            getTextStyle={getTextStyle}
            keepTogether={keepTogether}
          />
        )}
      </View>
      );
    })}
  </View>
);

export default RenderClauses;
